import { momentFormatted } from 'kb-shared/utilities/momentHelpers';
import { currencyNumberFormat } from 'utilities/number-format';

export const formatAmount = (amount: number) => currencyNumberFormat(amount / 100.0);

export const formatReason = (reason: string | null) => reason || '-';

export const formatDate = (date: string | null) =>
  date ? momentFormatted(date, 'MM/DD/YYYY') : '-';
